<!--Header-->
<div class="modal-header" style="border-bottom: none;">
    <div class="col-md-12 col-sm-12 col-12">
      <div class="row">
        <div class="col-md-9 col-sm-10 col-10" style="padding-left: 0px;">
          <h4 class="modal-title"><span id="ApntmntHdr" style="font-size: 22px;">Select Executive</span></h4>
        </div>
        <div class="col-md-3 col-sm-2 col-2" style="padding: 0px;">
          <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="passBack()"></i>
        </div>
      </div>
    </div>
  </div>
  <!--Body-->
  <div class="modal-body" style="padding-top: 10px;">
    <div class="col-md-12 col-sm-12 col-12" style="padding: 0px;">
        <div class="col-md-8 col-sm-8 col-8" style="display: inline-block; padding: 0px;">
            <select class="label Bluebadge form-control" [(ngModel)]="selected.id" style="display: inline-block; font-size: 13px; background: inherit;">
            <option value="0" selected disabled>Select</option>
            <option *ngFor="let c of executives" [ngValue]="c.UserID">{{c.Name}}</option>  
            </select>
        </div>
    </div>
  </div>
  <!--Footer-->
    <div class="" style="padding: 15px; border: none; text-align: left; float: left; padding-top: 0px;">
        <span class="btn btn-save brdrRadius3" style="padding: 2px 10px; font-size: 14px; line-height: 23px;" (click)="save()">
        <i class="zmdi zmdi-check" style="margin-right: 5px;"></i>
        <span style="font-size: 13px;">Select</span>
        </span>
    </div>
